import { captureException } from './sentry';

const isDevelopment = process.env.NODE_ENV !== 'production';

export const logger = {
    /**
     * Логирование информационных сообщений
     * @param {...any} args - Аргументы для логирования
     */
    log: (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
        // В production можно отправлять в систему мониторинга
    },

    /**
     * Логирование ошибок
     * @param {...any} args - Аргументы для логирования
     */
    error: (...args) => {
        if (isDevelopment) {
            console.error(...args);
        } else {
            const err = args[0] instanceof Error ? args[0] : new Error(String(args[0]));
            captureException(err, { extra: { details: args.slice(1) } });
        }
    },

    /**
     * Логирование предупреждений
     * @param {...any} args - Аргументы для логирования
     */
    warn: (...args) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    },

    /**
     * Логирование отладочной информации
     * @param {...any} args - Аргументы для логирования
     */
    debug: (...args) => {
        if (isDevelopment) {
            console.debug(...args);
        }
    },

    /**
     * Логирование информации (аналог console.info)
     * @param {...any} args - Аргументы для логирования
     */
    info: (...args) => {
        if (isDevelopment) {
            console.info(...args);
        }
    },
};
